import React, { useEffect, useState } from "react";
import GridTable from "../../components/GridTable";
import Input from "../../components/Input";

import { useDispatch, useSelector } from "react-redux";
import { getDesignation, getDesignationState } from "./designationSlice";
import { formatDateToDDMMYYYY } from "../../uitls/Utils";
import Swal from "sweetalert2";
import {
  createDesignation,
  deleteDesignation,
  getAllDesignation,
  updateDesignation,
} from "../../api/designationApi";
import { DialogCustomAnimation } from "../../components/dialog";

import Loader from "../../components/Loader";

const columns = [
  {
    field: "designations",
    headerName: "Job Title Name",
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "createdDate",
    headerName: "Created Date",
    width: 200,
    headerClassName: "super-app-theme--header",
  },
  {
    field: "updateDate",
    headerName: "Updated Date",
    width: 200,
    headerClassName: "super-app-theme--header",
  },
];
export default function Designation() {
  const dispatch = useDispatch();
  const allDesignation = useSelector(getDesignation);
  const stateOfDesignation = useSelector(getDesignationState);

  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState({
    name: "",
   
  });
  const [rows, setRows] = useState([]);

  const [type, setType] = useState(false);
  const [edit, setEdit] = useState();

  useEffect(() => {
    dispatch(getAllDesignation());
  }, [dispatch]);

  useEffect(() => {
    if (Array.isArray(allDesignation)) {
      const formattedRows = allDesignation.map((designations, index) => ({
        id: designations.id,
        designations: designations.name,
        createdDate: formatDateToDDMMYYYY(designations.createdDate),
        updateDate: formatDateToDDMMYYYY(designations.updatedDate),
      }));

      setRows(formattedRows);
    }
  }, [allDesignation]);

  const resetStates = () => {
    setType(false);
    setEdit(null);
    setFormErrors(null);
    setFormValues(null);
  };

  const handleDelete = (id) => {
    Swal.fire({
      titleText: "Delete Job Title ?",
      text: "Are you sure want to delete this Job Title?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc2626", // Red for destructive action
      cancelButtonColor: "#3C50E0", // Primary color for cancel
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
      customClass: {
        popup: "custom-swal-width", // Custom width of the popup
        icon: "custom-swal-icon", // Custom icon size
        title: "custom-swal-title", // Custom title size
        content: "custom-swal-content", // Custom content (text) size
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteDesignation(id))
          .unwrap()
          .then(() => {
            resetStates();
          })
          .catch((error) => {
          
            // Swal.fire({
            //   title: "Error!",
            //   text: error?.message||"Failed to delete Job Title. Please try again.",
            //   icon: "error",
            //   confirmButtonColor: "#dc2626",
            //   customClass: {
            //     popup: "custom-swal-width",
            //     icon: "custom-swal-icon",
            //     title: "custom-swal-title",
            //     content: "custom-swal-content",
            //   },
            // });
          });
      }
    });
  };

  const handleUpdate = (id) => {
    const selectedDesignation = allDesignation.find((item) => item.id === id);
    if (selectedDesignation) {
      setFormValues({
        name: selectedDesignation.name,
      });
      setEdit(selectedDesignation.id);
      setType(true);
    }
  };

  const handleCancelClick = () => {
    resetStates();
  };

  const trimObjectValues = (obj) => {
    if (Array.isArray(obj)) {
      return obj.map(trimObjectValues);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).reduce((acc, key) => {
        acc[key] = trimObjectValues(obj[key]);
        return acc;
      }, {});
    } else if (typeof obj === "string") {
      return obj.trim();
    }
    return obj;
  };

  const handleSubmitDesignation = () => {
    if (
      !formValues?.name ||
      formValues?.name === "" ||
      !formValues?.name?.trim()
    ) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        name: "Job Title is required",
      }));
      return;
    }
    if (edit) {
      dispatch(
        updateDesignation({ id: edit, data: trimObjectValues(formValues) })
      )
        .unwrap()
        .then(() => {
          resetStates();
        })
        .catch((error) => {
         
          // Swal.fire({
          //   title: "Error!",
          //   text: error?.message||"Failed to update Job Title. Please try again.",
          //   icon: "error",
          //   confirmButtonColor: "#dc2626",
          //   customClass: {
          //     popup: "custom-swal-width",
          //     icon: "custom-swal-icon",
          //     title: "custom-swal-title",
          //     content: "custom-swal-content",
          //   },
          // });
        });
    } else {
      dispatch(createDesignation(trimObjectValues(formValues)))
        .unwrap()
        .then(() => {
          resetStates();
        })
        .catch((error) => {
          // Swal.fire({
          //   title: "ALERT Error!",
          //   text: error?.message||"Failed to add Job Title. Please try again.",
          //   icon: "error",
          //   confirmButtonColor: "#dc2626",
          //   customClass: {
          //     popup: "custom-swal-width",
          //     icon: "custom-swal-icon",
          //     title: "custom-swal-title",
          //     content: "custom-swal-content",
          //   },
          // });
        });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value ? "" : "Required Field",
    }));
  };

  const onClickAction = (actions, rows) => {
    if (actions === "EDIT") {
      handleUpdate(rows.id);
    } else if (actions === "DELETE") {
      handleDelete(rows.id);
    }
  };
  return (
    <div className="pt-4 md:pt-6 2xl:pt-10 w-full px-4 md:px-6 lg:px-8">
      {stateOfDesignation?.loading && <Loader />}
      <GridTable
        onClickAction={onClickAction}
        actions={["DELETE", "EDIT"]}
        rowData={rows}
        columnData={columns}
        toolTipName={"Add Job Title"}
        onClickAdd={() => setType(true)}
      />

      <DialogCustomAnimation
        open={type}
        handleClose={handleCancelClick}
        header={edit ? "Update Job Title" : "Add Job Title"}
        handleSave={handleSubmitDesignation}
        size="sm"
        body={
          <div className="w-full">
            <div className="space-y-3">
              <div className="flex items-center gap-3 mb-3">
                <div className="p-2 bg-blue-50 rounded-lg">
                  <svg
                    className="w-5 h-5 text-blue-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0V6a2 2 0 012 2v6a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2V6"
                    />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-gray-800">
                    Job Title Information
                  </h3>
                  <p className="text-sm text-gray-600">
                    Enter the job title name for the organization
                  </p>
                </div>
              </div>

              <Input
                name="name"
                placeholder="Enter Job Title name"
                value={formValues?.name || ""}
                onChange={handleInputChange}
                label="Job Title"
                requiredField={true}
                error={formErrors?.name || ""}
              />
            </div>
          </div>
        }
      />

    
    </div>
  );
}
